import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Spinner } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroller';
import { HiLogout } from '@react-icons/all-files/hi/HiLogout';
import { useAuth } from '../../auth/Auth';
import { myRoomViewModel } from './my.room.viewmodel';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import tribeVeryfied from '../../../assets/images/verified-badge.png';
import greenTick from '../../../assets/icon/green_tick.svg';
import notVerified from '../../../assets/icon/Unverified.svg';
import uniProfile from '../../../assets/profile/default-profile-uni.svg';
import TribeCamp from '../camp_schedule/TribeCamp';
import moment from 'moment';
import { schoolViewModel } from '../school/school.view.model';

const MyRoomLeftSideBar = (props) => {
  const _PAGE_LIMIT = 20;
  const { tid } = useParams();
  const [width, setWidth] = useState(window.innerWidth);
  const { dependent, school, fetchAPI } = useAuth();
  const [showLayout, setShowLayout] = useState(
    dependent?.profile?.group?.id ? true : school ? true : false
  );
  const [tribeMembersList, setTribeMembersList] = useState([]);
  const [treehouseSubscribers, setTreehouseSubscribers] = useState([]);
  const [treehouseId, setTreehouseId] = useState('');
  const [selectedTribe, setSelectedTribe] = useState('All');
  const [mobileDisplay, setMobileDisplay] = useState('');
  const [schoolDependentsLoading, setSchoolDependentsLoading] = useState(false);
  const [available, setAvailable] = useState(false);
  const [specialCamp, setSpecialCamp] = useState({});
  const [collapseClass, setCollapseClass] = useState(
    isMobile ? '' : showLayout ? '' : 'collapsse'
  );
  const [campMasterSpecialCamp, setCampMasterSpecialCamp] = useState({});
  const [tribeQuery, setTribeQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
    group_id: dependent?.profile?.group.id,
  });
  const [allTribeQuery, setAllTribeQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
  });
  const [treehouseQuery, setTreehouseQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
  });
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [width]);
  const setCollapsse = () => {
    if (showLayout) {
      props.setLeftCollapsse('left-collapsse');
      setCollapseClass('collapsse');
    } else {
      props.setLeftCollapsse('');
      setCollapseClass('');
    }
    setShowLayout(!showLayout);
  };

  const getTribeMembers = () => {
    if (dependent?.profile?.group.id) {
      let previousList = tribeMembersList;
      fetchAPI(myRoomViewModel.getTribeMembers, tribeQuery, previousList)
        .then((res) => {
          ReactDOM.unstable_batchedUpdates(() => {
            setTribeMembersList(res.List);
            setTribeQuery(res.query);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getAllTribeMembers = () => {
    if (dependent?.profile?.group.id) {
      let previousList = tribeMembersList;
      const schoolId = props.treehouse?.camp_details?.id;
      fetchAPI(
        myRoomViewModel.getAllTribeMembers,
        allTribeQuery,
        previousList,
        schoolId
      )
        .then((res) => {
          ReactDOM.unstable_batchedUpdates(() => {
            setTribeMembersList(res.List);
            setAllTribeQuery(res.query);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getDependents = () => {
    if (treehouseId[0]?.id) {
      let groups = [treehouseId[0]?.id];
      let previousList = treehouseSubscribers;
      let depQuery = { ...treehouseQuery };
      depQuery.group = treehouseId[0]?.id;
      let API =
        school?.user_type === 'school'
          ? schoolViewModel.getTribeDependents
          : schoolViewModel.getCampCaptainDependents;
      fetchAPI(API, depQuery, previousList, groups)
        .then((res) => {
          ReactDOM.unstable_batchedUpdates(() => {
            setTreehouseSubscribers(res.List);
            setTreehouseQuery(res.query);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setTreehouseSubscribers([]);
      setTreehouseQuery({ ...treehouseQuery });
    }
  };

  const getSchoolDependents = () => {
    if (school) {
      if (!schoolDependentsLoading) {
        setSchoolDependentsLoading(true);
        if (treehouseId === 'All') {
          let groups = [];
          let previousList = treehouseSubscribers;
          props.treehousesList.forEach((obj) => groups.push(obj.id));
          let API =
            school?.user_type === 'school'
              ? schoolViewModel.getCampDependents
              : schoolViewModel.getCampCaptainDependents;
          fetchAPI(API, treehouseQuery, previousList, groups)
            .then((res) => {
              ReactDOM.unstable_batchedUpdates(() => {
                setTreehouseSubscribers(res.List);
                setTreehouseQuery(res.query);
                setSchoolDependentsLoading(false);
              });
            })
            .catch((err) => {
              console.log(err);
              setSchoolDependentsLoading(false);
            });
        }
      }
    }
  };

  useEffect(() => {
    if (dependent) {
      if (!dependent?.profile?.group?.id && !isMobile) {
        props.setLeftCollapsse('left-collapsse');
      }
    }
  }, []);

  useEffect(() => {
    if (school) {
      setTreehouseId(props.selectedTreehouse);
      setTreehouseSubscribers([]);
      setTreehouseQuery({
        limit: _PAGE_LIMIT,
        has_more: true,
      });
    }
    if (dependent) {
      setSelectedTribe(props.selectedTreehouse);
      setTribeMembersList([]);
      setTribeQuery({
        limit: _PAGE_LIMIT,
        has_more: true,
        group_id: dependent?.profile?.group.id,
      });
      setAllTribeQuery({
        limit: _PAGE_LIMIT,
        has_more: true,
      });
    }
  }, [props.selectedTreehouse]);

  useEffect(() => {
    if (selectedTribe === 'All') {
      getAllTribeMembers();
      // setTreehouseId("All")
    } else {
      getTribeMembers();
    }
  }, [selectedTribe]);

  useEffect(() => {
    if (treehouseId === 'All') {
      getSchoolDependents();
    } else {
      getDependents();
    }
  }, [treehouseId]);

  useEffect(() => {
    if (isMobile && width < 1200) {
      if (props.rightCollapsse === 'right-collapsse') {
        setMobileDisplay('none');
      } else {
        setMobileDisplay('');
      }
    }
  }, [props.rightCollapsse]);

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <div
      id="tribe-lists"
      style={{ display: mobileDisplay }}
      className={`flex-col-left ${collapseClass}`}
    >
      <div className="challenges-left-accordian">
        <div
          className={`accordian-col my-interests my-tribes`}
          id="captain-step-commonroom"
        >
          <div className="accordian-head">
            <span className={`hide-on-toggle `}>
              {school
                ? props?.selectedTreehouse === 'All'
                  ? `All Tribes`
                  : `Tribe: ${props?.selectedTreehouse[0]?.name}`
                : dependent
                ? dependent?.profile?.group?.id === Number(tid)
                  ? props.selectedTreehouse === 'All'
                    ? 'All Tribes'
                    : `My Tribe: ${dependent?.profile?.group?.name}`
                  : 'My Tribe'
                : 'My Tribe'}
            </span>
            {dependent && props?.selectedTreehouse !== 'All' && (
              <p className="my-tribes-status hide-on-toggle">{`Gathering, ${capitalizeFirstLetter(
                props.treehouse?.day
              )} at ${moment(props.treehouse?.time, ['HH:mm:ss']).format(
                'hh:mm a'
              )}`}</p>
            )}
            {school ? (
              props?.selectedTreehouse !== 'All' ? (
                <p className="my-tribes-status hide-on-toggle">{`Gathering, ${capitalizeFirstLetter(
                  props?.selectedTreehouse[0]?.day
                )} at ${moment(props?.selectedTreehouse[0]?.time, [
                  'HH:mm:ss',
                ]).format('hh:mm a')}`}</p>
              ) : (
                campMasterSpecialCamp?.id && (
                  <p className="my-tribes-status hide-on-toggle">{`Special Camp: ${campMasterSpecialCamp?.name}`}</p>
                )
              )
            ) : (
              ''
            )}
            <span className={`dropdown-ic ${collapseClass}`}>
              {' '}
              <a
                className={school ? '' : 'left-dropdown-btn'}
                href="javascript:void(0);"
                onClick={setCollapsse}
              >
                {' '}
                {school ? <HiLogout /> : `  `}
              </a>
            </span>
            {school && school?.user_type === 'school' && (
              <TribeCamp
                {...props}
                setCampMasterSpecialCamp={setCampMasterSpecialCamp}
              />
            )}
          </div>

          {dependent &&
            dependent?.profile?.group?.id &&
            props.selectedTreehouse !== 'All' && (
              <ul
                id="tribe-lists"
                style={{ marginBottom: 0, border: '1px solid transparent' }}
                className={`tribe-lists `}
              >
                <li
                  className="tribe-first-child"
                  onClick={() => {
                    props?.setSelectedMember({});
                  }}
                >
                  <span className="tribe-avatar">
                    <img
                      src={
                        dependent?.school_details?.tribe_picture
                          ? dependent?.school_details?.tribe_picture
                          : uniProfile
                      }
                      alt="Tribe"
                    />
                  </span>
                  {`${dependent?.profile?.group?.captain_details?.first_name} ${dependent?.profile?.group?.captain_details?.last_name} (Captain)`}
                  <span className="tribe-veryfied">
                    <img src={tribeVeryfied} alt="Tribe Verified" />
                  </span>
                </li>
              </ul>
            )}
          {dependent && tribeMembersList.length > 0 && (
            <InfiniteScroll
              pageStart={0}
              loadMore={
                props.selectedTreehouse === 'All'
                  ? getAllTribeMembers
                  : getTribeMembers
              }
              hasMore={
                props.selectedTreehouse === 'All'
                  ? allTribeQuery.has_more
                  : tribeQuery?.has_more
              }
              // threshold={150}
              className="home-feed-spinner-wrapper"
              // initialLoad={false}
              // useWindow={false}
              // getScrollParent={() => document.getElementById('tribe-lists')}
              loader={
                tribeMembersList &&
                tribeMembersList.length <= 0 && (
                  <Spinner
                    key={0}
                    className="home-feed-spinner"
                    animation="border"
                    variant="info"
                  />
                )
              }
            >
              <ul
                id="tribe-lists"
                style={{
                  height: school
                    ? props.selectedTreehouse !== 'All'
                      ? '60vh'
                      : '90vh'
                    : '90vh',
                  overflow: 'auto',
                  border: '1px solid transparent',
                }}
                className={`tribe-lists `}
              >
                {dependent &&
                  tribeMembersList
                    .filter(
                      (obj) =>
                        obj?.profile?.tribe_request_status === 'accept' &&
                        obj?.profile?.is_activated === true
                    )
                    .map((item, key) => {
                      return (
                        <li
                          className={`add-pointer ${
                            props?.selectedMember.id === item.id ? 'active' : ''
                          }`}
                          key={key}
                          onClick={() => {
                            if (isMobile) {
                              setCollapsse();
                            }
                            props.handleMemberCLick(item);
                          }}
                        >
                          <span className="tribe-avatar">
                            <img src={getUserProfileUrl(item)} alt="Tribe" />
                          </span>
                          {`${item?.username}`}
                          <span className="tribe-veryfied">
                            <img
                              src={
                                item?.is_verified ? tribeVeryfied : notVerified
                              }
                              alt="Tribe Verified"
                            />
                          </span>
                        </li>
                      );
                    })}
              </ul>
            </InfiniteScroll>
          )}
          {school && treehouseId && (
            <ul
              id="tribe-lists"
              style={{ marginBottom: 0, border: '1px solid transparent' }}
              className={`tribe-lists `}
            >
              <li
                className="tribe-first-child add-pointer"
                onClick={() => {
                  if (isMobile) {
                    setCollapsse();
                  }
                  props?.setSelectedMember({});
                }}
              >
                <span className="tribe-avatar">
                  <img
                    src={
                      school?.user_type === 'school_teacher'
                        ? school?.profile?.picture_url
                          ? school?.profile?.picture_url
                          : uniProfile
                        : props.selectedTreehouse === 'All'
                        ? school?.picture_url
                          ? school?.picture_url
                          : uniProfile
                        : props.selectedTreehouse[0]?.profile?.picture_url
                        ? props.selectedTreehouse[0]?.profile?.picture_url
                        : uniProfile
                    }
                    alt="Tribe"
                  />
                </span>
                {props?.selectedTreehouse === 'All'
                  ? `${school?.first_name} ${school?.last_name} (${
                      school?.user_type === 'school' ? 'Master' : 'Captain'
                    })`
                  : `${props.selectedTreehouse[0]?.captain_details?.first_name} ${props.selectedTreehouse[0]?.captain_details?.last_name} (Captain)`}
                <span className="tribe-veryfied">
                  <img
                    src={
                      props.selectedTreehouse[0]?.id
                        ? !props.selectedTreehouse[0]?.captain_details
                            ?.is_verified
                          ? notVerified
                          : tribeVeryfied
                        : !school?.is_verified
                        ? notVerified
                        : school?.user_type === 'school'
                        ? greenTick
                        : tribeVeryfied
                    }
                    alt="Tribe Verified"
                  />
                </span>
              </li>
            </ul>
          )}
          {school && treehouseId && (
            <InfiniteScroll
              pageStart={0}
              loadMore={
                treehouseId === 'All' ? getSchoolDependents : getDependents
              }
              hasMore={treehouseQuery.has_more}
              // threshold={150}
              className="home-feed-spinner-wrapper"
              // initialLoad={false}
              // useWindow={false}
              // getScrollParent={() => document.getElementById('tribe-lists')}
              loader={
                treehouseSubscribers &&
                treehouseSubscribers.length <= 0 && (
                  <Spinner
                    key={0}
                    className="home-feed-spinner"
                    animation="border"
                    variant="info"
                  />
                )
              }
            >
              <ul
                id="tribe-lists"
                style={{
                  height: school
                    ? props.selectedTreehouse !== 'All'
                      ? '60vh'
                      : '90vh'
                    : '90vh',
                  overflow: 'auto',
                  border: '1px solid transparent',
                }}
                className={`tribe-lists `}
              >
                {treehouseSubscribers
                  .filter(
                    (obj) =>
                      obj?.profile?.tribe_request_status === 'accept' &&
                      obj?.profile?.is_activated === true
                  )
                  .map((item, key) => {
                    return (
                      <li
                        className={`add-pointer ${
                          props?.selectedMember.id === item.id ? 'active' : ''
                        }`}
                        key={key}
                        onClick={() => {
                          if (isMobile) {
                            setCollapsse();
                          }
                          props.handleMemberCLick(item);
                        }}
                      >
                        <span className="tribe-avatar">
                          <img src={getUserProfileUrl(item)} alt="Tribe" />
                        </span>
                        {`${item?.username}`}
                        <span className="tribe-veryfied">
                          <img
                            src={
                              item?.is_verified ? tribeVeryfied : notVerified
                            }
                            alt="Tribe Verified"
                          />
                        </span>
                      </li>
                    );
                  })}
              </ul>
            </InfiniteScroll>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyRoomLeftSideBar;